// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/utils/v1/encoding.proto (package chalk.utils.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/utils/v1/encoding.proto.
 */
export const file_chalk_utils_v1_encoding: GenFile = /*@__PURE__*/
  fileDesc("Ch1jaGFsay91dGlscy92MS9lbmNvZGluZy5wcm90bxIOY2hhbGsudXRpbHMudjEifgoOU3RyaW5nRW5jb2RpbmcSPAoHbWFwcGluZxgBIAMoCzIrLmNoYWxrLnV0aWxzLnYxLlN0cmluZ0VuY29kaW5nLk1hcHBpbmdFbnRyeRouCgxNYXBwaW5nRW50cnkSCwoDa2V5GAEgASgFEg0KBXZhbHVlGAIgASgJOgI4ATpdCghlbmNvZGluZxIcLmdvb2dsZS5wcm90b2J1Zi5FbnVtT3B0aW9ucxic9AQgASgLMh4uY2hhbGsudXRpbHMudjEuU3RyaW5nRW5jb2RpbmdSCGVuY29kaW5niAEBYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * @generated from message chalk.utils.v1.StringEncoding
 */
export type StringEncoding = Message<"chalk.utils.v1.StringEncoding"> & {
  /**
   * @generated from field: map<int32, string> mapping = 1;
   */
  mapping: { [key: number]: string };
};

/**
 * Describes the message chalk.utils.v1.StringEncoding.
 * Use `create(StringEncodingSchema)` to create a new message.
 */
export const StringEncodingSchema: GenMessage<StringEncoding> = /*@__PURE__*/
  messageDesc(file_chalk_utils_v1_encoding, 0);

/**
 * @generated from extension: optional chalk.utils.v1.StringEncoding encoding = 80412;
 */
export const encoding: GenExtension<EnumOptions, StringEncoding> = /*@__PURE__*/
  extDesc(file_chalk_utils_v1_encoding, 0);

